import { useEffect, useState } from "react";
import { selectExceptionLevels, selectExceptionLevelsLoading, selectExceptions, selectExceptionsLoading } from "../../redux/exceptions/selectors";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { openModal } from "../../redux/modal/modalSlice";
import { createException, deleteException, getExceptionLevels, getExceptions, updateException } from "../../redux/exceptions/thunks";


const initialSortOptions = {
    columna: "exceptionId",
    sortOrderAsc: true

}

function ExceptionManagement() {
    const exceptions = useSelector(selectExceptions);
    const exceptionLevels = useSelector(selectExceptionLevels)
    const dispatch = useDispatch();
    const loading = useSelector(selectExceptionsLoading);
    const loadingLevels = useSelector(selectExceptionLevelsLoading)
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    

    useEffect(()=>{
        getListExceptions(mapPageInfo(exceptions));
        dispatch(getExceptionLevels());
    }, [])

    function mapPageInfo(exceptionsData){
        return {
            pageIndex: exceptionsData.pageIndex ?? 0,
            pageSize: exceptionsData.pageSize ?? 10,
            orderByField: exceptionsData.columna ?? "exceptionId",
            orderByAscending: exceptionsData.sortOrderAsc ?? true
        }
    }
      
    const getListExceptions = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getExceptions({query}));
    }

    const columnsExceptions = [
        <Column sortIndex={1} key={"exception-1"} dataField="exceptionId" width={100} caption="Id" allowEditing={false} allowCreating={false}/>,
        <Column key={"exception-2"} dataField="level" width={150} caption="Nível" lookup={{multiple: false, allowClearing: false, dataSource: exceptionLevels, displayExpr: "levelKey", valueExpr: "exceptionLevelId"}}/>, 
        <Column key={"exception-3"} dataField="key"  dataType={"string"} width={150} caption="Código"/>,
        <Column key={"exception-4"} dataField="label" dataType={"string"} width={150} caption="Conceito"/>,
        <Column key={"exception-5"} dataField="text" dataType={"textarea"} caption="Descrição" />
    ] 

    function handleSaveNewExceptionClick(value, closeCreateModal) {   
                dispatch(createException({body: value})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListExceptions(mapPageInfo({...exceptions, ...sortOptions}));
                        closeCreateModal();
                    }                    
                })     
    }    

    const handleEditClick = (value, closeEditModal) => {
                dispatch(updateException({body: value, param: value.exceptionId})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListExceptions(mapPageInfo({...exceptions, ...sortOptions}));
                        closeEditModal()
                    }    
                })      
    }

    const handleDeleteClick = (exceptionId, closeDeleteModal) => {
        dispatch(deleteException({query: exceptionId})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = exceptions.pageIndex;

                if (exceptions.elements.length === 1) {
                    updatedPageIndex = Math.max(0, exceptions.pageIndex - 1);
                }

                const updatedExceptions = {
                    ...exceptions,
                    pageIndex: updatedPageIndex,
                };

                getListExceptions(mapPageInfo({...updatedExceptions, ...sortOptions}));
                closeDeleteModal()           
            }
        })  
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                defaultSortField={"exceptionId"}
                sectionTitle={"Exceções"}
                masterTitle={"Exceção"} 
                itemIdField={"exceptionId"} 
                itemDescriptionField={"exceptionId"} 
                loading={loading} 
                getData={getListExceptions} 
                dataSource={exceptions} 
                columnasTabla={columnsExceptions} 
                onCreate={handleSaveNewExceptionClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[15, 50, 100]}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
}
export default ExceptionManagement;